import { useEffect, useState } from 'react';
import { getCountDays } from '../helpers/getCountDays';
import moment from 'moment';
import { useEditStage } from './useEditStage';

export const useMoveStage = (stage, activeTab) => {
    const [positionX, setPositionX] = useState(0);
    const [needMoveUpdate, setNeedMoveUpdate] = useState(false);

    const { moveStageNew, updateAll } = useEditStage(stage);

    const handleMouseMove = (value) => {
        setPositionX((prevState) => prevState + value);
    };

    const handleMouseUp = () => {
        setNeedMoveUpdate(true);
    };

    useEffect(() => {
        if (needMoveUpdate) {
            const startDate = stage.planned.start_date ? stage.planned.start_date : '';
            const start_date = getCountDays(positionX, startDate, activeTab);

            const dateDiff = moment(start_date).diff(startDate, 'days');

            let resultUpdating = {};

            if (dateDiff !== 0) {
                const resultMove = moveStageNew(dateDiff, resultUpdating);
                updateAll(resultMove);
            }
            setPositionX(0);
            setNeedMoveUpdate(false);
        }
    }, [needMoveUpdate]);

    return {
        positionX,
        handleMouseMove,
        handleMouseUp,
    };
};
